import { LanguageSelector, Megamenu, MenuItem, MenuItems } from 'core/layout/Navigation'
import { breakpoint } from "core/layout/styles"
import { Title } from 'core/styles/Title'
import { Tabs, Panel } from 'core/styles/Tabs'
import { HeaderContainer, Logo, Content as HeaderContent } from "core/layout/Header"
import { createGlobalStyle } from "styled-components"
import { BannerItem as MixedBannerItem, Container as MixedBannerContainer, MediaContainer, Wrapper as MixedBannerWrapper } from "core/components/MixedContentBanner"
import { BannerItem as FullWidthBanner } from "core/components/FullWidthBanner"
import { Container as NewsletterContainer, Content as NewsletterContent, Wrapper as NewsletterWrapper, Row as NewsletterRow } from "core/components/Newsletter"
import { Cta } from "core/styles/Cta"
import { Container as FooterContainer, Navigation as FooterNavigation, Social as FooterSocial, Logo as FooterLogo, NewsletterCTASection as FooterNewsletterCTA } from "core/layout/Footer"
import { Filter, FilterGroup } from "core/styles/Filter";
import { NavButton } from "core/layout/Navigation"

import { Wrapper, CardLink, MainCard, ImageWrapper } from "core/components/Card";
import { PrepInfo, PrepItem, Description } from "core/components/Recipe"
import { Container as BannerContainer, Item as BannerItem, Content as BannerContent, Image as BannerImage } from "core/styles/Banner"
import { Section as CategoriesSection, Cta as CategoriesCta } from "core/components/Categories"

import { VideoContainer } from "core/components/VideoBanner"
import { Container as HeaderBannerContainer } from "core/components/HeaderBanner"
import { Container as FeaturedCarouselContainer } from "core/components/FeaturedCarousel"
import { FeaturedCard } from "core/components/FeaturedRecipe"
import { Preview, Thumbnail, Wrapper as ProductWrapper } from "core/components/Product"
import { ListingHeader } from "core/styles/Listing"
import { Grid } from "core/styles/Grid"

const GlobalStyles = createGlobalStyle`
  :root {
    --blue: #2A80C3;
    --lightblue: #9DD8E6;
    --black: #000000;
    --daisy-white: #F7F4E3;
    --mustard: #E6B10E;
    --white: white;
    --ocean: #74BAA0;
    --orange: #F15A30;
    --warm-orange: #F26539;

    --background: white;
    --text: black;
    --border: rgba(0,0,0,0.4);

    --primary: var(--black);
    --secondary: rgba(102, 102, 102, 1);

    --notification-text: #ffffff;
    --notification-bg: var(--primary);
    --outline: var(--black);

    --swiper-pagination-color: var(--primary);
    --swiper-pagination-bullet: #ffffff;
    --swiper-pagination-border:var(--primary);


    --featured-recipes-background: var(--lightblue, --background);
    --preview-size: 260px;
  }
  
  html {
    &.menu-is-open {
      @media screen and ${breakpoint.mobile} {
        overflow: hidden;
      }
    }
  }


  body {
    font-family: GothamBook;
    
    &.menu-is-open {
      @media screen and ${breakpoint.mobile} {
        overflow: hidden;
      }
    }
  }
  
  

  a:active,
  a:hover {
    outline: 0
  }

  a:focus {
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: 5px;
  }

  h1, h2, h3, h4, h5, h6 {
    text-transform: uppercase;
    font-family:GothamMedium;
  }

  input {
    border-radius: 0px;
    box-shadow: none;
    border: 1px solid var(--border);
    font-family: GothamMedium;
  }

  .cta {
    &&& {
      background: black;
      color: white;
      padding: 10px 20px;
      border-radius: 2.5px;
      font-size: 16px;
    }
  }

  ${HeaderContainer} {
    background: black;
    border: 0;
    z-index: 11;
    @media ${breakpoint.desktop} {
      background: white;
    }
    ${HeaderContent} {
      @media ${breakpoint.desktop} {
        margin-bottom: 24px;
      }
    }
    ${Logo} {
      padding: 0;
      img {
        height: 60px;
        width: 60px;
        transform: scale(1.5);
        @media ${breakpoint.desktop} {
          transform: none;
          height: 140px;
          width: 140px;
        }
      }

      position: relative;
      top: -12px;
      overflow: hidden;
      @media ${breakpoint.desktop} {
        position: static;
      }
    }
  }
  
  ${Megamenu} {
    font-weight: 100 !important;
    @media ${breakpoint.desktop} {
      width: 111%;
      margin-left: 0;
    }
      @media ${breakpoint.tablet_down} {
        width: 100%;
        padding-right: 24px;
      }
  }

  ${MenuItems} {
    top: 60px;
    border-top: 0;
    @media ${breakpoint.desktop_down} {
      max-height: 100vh;
      overflow-y: scroll;
    }
    @media ${breakpoint.desktop} {
      align-items: center;
    }
  }

  ${MenuItem} {
    &&& {
      a, span {
        font-family: GothamMedium,serif;
        font-size: 1rem;
      }
    }
    --nav-text: black;
    --nav-bg: white;
    --nav-text-selected: black;
    --nav-bg-selected: white;
    @media ${breakpoint.desktop} {
      --nav-text: inherit;
      --nav-bg: inherit;
      --nav-text-selected: inherit;
      --nav-bg-selected: inherit;
    }
    &&& {
      li {
        a {
          font-family: GothamBook,serif;
          
          @media ${breakpoint.tablet_down} {
            &:hover {
              background: var(--background);
              color: var(--text);
            }
          }
        }
      }
    }
    @media ${breakpoint.desktop} {
      margin: 0 15px;
    }
  }

  ${LanguageSelector} {
    &&& {
      --nav-text: black;
      --nav-bg: rgba(0,0,0,0);
      --nav-text-selected: black;
      --nav-bg-selected: rgba(0,0,0,0);
      @media ${breakpoint.desktop} {
        --nav-text: black;
        --nav-bg: rgba(0,0,0,0);
        --nav-text-selected: black;
        --nav-bg-selected: rgba(0,0,0,0);
      }
    }
  }

  ${FooterContainer} {
    padding: 0;
  }

  ${FooterNavigation} {
    padding: 0;
    @media ${breakpoint.desktop} {
      padding: 100px 0;
    }
    h4 {
      text-transform: inherit;
    }
    > ul ul li {
      font-size: 14px;
    }
  }

  ${FooterSocial} {
    padding: 0;
    @media ${breakpoint.desktop} {
      padding-top: 30px;
    }
  }

  ${FooterNewsletterCTA} {
    padding: 0;
    @media ${breakpoint.desktop} {
      padding-top: 100px;
    }

    button {
      width: 100%;
      max-width: 220px;
    }
  }

  ${FooterLogo} {
    @media ${breakpoint.desktop} {
      margin-right: 100px;
    }
  }
  
  ${PrepInfo} {
    @media ${breakpoint.desktop} {
      flex-direction: column;
    }
  }

  ${PrepItem} {
    margin: 1rem;
  }

  ${Title} {
    font-family: GothamMedium;
    font-size: 28px;
    @media ${breakpoint.desktop} {
      font-size: 36px;
    }
  }

  ${ProductWrapper} {
    ${Title} {
      text-transform: none;
    }
  }


  ${Description} {
    font-size: 14px;
    @media ${breakpoint.desktop} {
      font-size: 16px;
    }
  }
  ${Tabs} {
    font-family: GothamMedium;
  }

  ${Panel} {
    font-family: GothamBook;
    font-size: 16px;
  }

  ${MainCard} {
    &&&& {
      color: black;
      background: var(--daisy-white);
      justify-content: flex-end;
      padding-bottom: 36px;
      
      & > a { 
        color: black;
        text-transform: inherit;
        font-family: GothamMedium;
        font-size: 1rem;
      }
      &:hover {
        box-shadow: 0 0 0 1.5px white;
      }
    }
  }



  ${Wrapper} {
    ${CardLink} {
      box-shadow: 0px 4px 35px rgba(0, 0, 0, 0.1);
      position:relative;
      img {
        margin-bottom: 180px;
        padding: 0;
        max-width: 100%;
        max-height: 350px;
        object-fit: cover;
      }
      h4 {
        text-transform: inherit;
        color: white;
        background: black;
        font-family: GothamBold;
        font-size: 18px;
        line-height: 1.5;
        min-height: 180px;
        display: flex;
        align-items: center;
        padding: 0 2em;
        border-top-style: solid;
        border-top-width: 15px;
        flex: 1;
        position: absolute;
        bottom: 0;
        text-transform: capitalize;
      }
      &:after {
        position: absolute;
        height: 15px;
        bottom: 165px;
        top: unset;
        z-index: 2;
      }
      ${ImageWrapper} {
        width: 100%;
        height: 100%;
        display: block;
        transition: all ${(props) => (props.recipe ? '3s' : '750ms')} ease;
        image-rendering: -webkit-optimize-contrast;
        image-rendering: -moz-crisp-edges;
        position: relative;
        z-index: 1;
        pointer-events: none;
        padding-top: 0;
        padding-bottom: 180px;
        max-width: 100%;
        max-height: 100%;

        img {
          object-fit: cover;
          object-position: center center;
        }

        span {
          height: 100% !important;
          width: 100% !important;
        }
      }
    }
    p {
      margin: 0 0 2rem 0;
    }
  }

  ${FeaturedCarouselContainer} {
    ${CardLink} {
      h4 {
        font-size: 16px;
      }
    }
  }

  ${NewsletterRow} {
    @media ${breakpoint.desktop} {
      max-width: 100%;
    }
    margin: 0 0 1rem;
    p, span {

      font-family: GothamBook;
    }

    input {
      width: 100%;
      @media ${breakpoint.desktop} {
        width: 377px; 
      }
    }
    input[type="submit"] {
      margin-top: 2rem;
    }
  }

  ${NewsletterContainer} {
    background: var(--daisy-white);
  }

  ${NewsletterContent} {
    h3 {
      font-family: GothamMedium;
    }
    @media ${breakpoint.desktop} {
      max-width: 100%;
    }
    display: flex;
    flex-direction: column;
    align-items:flex-start;

    @media ${breakpoint.desktop} {
      align-items:center;
      padding: 100px 0;
      text-align: center;
    }
  }

  ${BannerContainer} {
    padding-top: 2.5em;;
  }
  
  ${BannerItem} {
    display: flex;
    &:before {
      background: transparent;
      @media ${breakpoint.desktop} {
        background: rgb(0,0,0);
        background: linear-gradient(to top, rgba(0,0,0,0.85) 20%, rgba(0,0,0,0) 80%);
      }
    }

    ${Cta} {
      background: black;
      color: white;
      padding: 10px 20px;
      border-radius: 2.5px;
      font-size: 16px;
      @media ${breakpoint.desktop} {
        color: black;
        background: white;
      }
    }
  }

  ${BannerImage} {
    height: 295px;
    background-size: cover !important;
  }
  ${BannerContent} {
    color: black;
    @media ${breakpoint.desktop} {
      color: white;
      width: 45%;
      max-width: 550px;
    }
    p {
      font-size: 14px;
      line-height: 18.2px;
      margin-top: 2rem;
      @media ${breakpoint.desktop} {
        font-size: 16px;
        line-height: 130%;
      }
    }
    h2 {
      font-family:GothamMedium;
      line-height: 110%;
      @media ${breakpoint.desktop} {
      }
      strong {
        font-size: 60px;
        line-height: 66px;
        display: block;
        @media ${breakpoint.desktop} {
          font-size: 72px;
          line-height: 80px;
        }
      }
    }
  }

  ${CategoriesSection} {
    text-align: left;
    position: relative;
    padding-bottom: var(--section-padding, 40px);
    display: flex;
    flex-direction: var(--section-direction, column);
    &:after {
      opacity: .2;
      content: '';
      display:block;
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      z-index: -2;
      background: var(--card-background);
    }
    p {
      font-size: 14px;
      font-family: GothamLight;
      line-height: 130%;
      padding-top: 20px;
      @media ${breakpoint.desktop} {
        font-size: 16px;
      }
    }
    strong  {
      font-family: GothamMedium;
      text-transform: uppercase;
    }
    h2 {
      background: var(--header-background);
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: left;
      margin:0;
      padding: 2rem 1rem;
      font-size: 21px;
      strong {
        font-size: 90px;
        display: block;
        line-height: 90px;
      }
    }
  }

  ${CategoriesCta} {
    margin-left: 24px;
    margin-top: 24px;
    font-size: 16px;
    margin-top: auto;
    width: fit-content;
    border-radius: 2.5px;
  }

  ${MediaContainer} {
    &&& {
      @media ${breakpoint.desktop} {
        padding: 0;
        img {
          min-width: 764px;
        }
      }
      img {
        max-height: 450px;
      }
    }
  }

  ${MixedBannerContainer} {
    &&& {
      ${Cta} {
        background: black;
        color: white;
      }
    }
  }

  ${MixedBannerWrapper} {
    & > div {
      display: flex;
      align-items: center;
    }
  }

  ${MixedBannerItem} {
    --component-height: 520px;
  }

  ${VideoContainer} {
    &, video {
      @media ${breakpoint.desktop} {
        height: 692px;
      }
    }
  }

  ${FullWidthBanner} {

    h2, p { 
      color: var(--text);
    }
    
    h2 {
      margin-top: 280px;
      @media ${breakpoint.desktop} {
        margin-top: 0;
      }
    }

    &&& {
      ${Cta} {
        background: var(--text);
        color: var(--background) !important;
        max-width: none;
      }
    }
    
    background-position-x: 100%;
    @media ${breakpoint.desktop} {
      background-position-x: inherit;
    }

  }

  ${FilterGroup} {
    white-space: nowrap;
  }

  ${Filter} {
    width: 220px;
  }

  ${HeaderBannerContainer} {
    position: relative;
    @media screen and ${breakpoint.desktop} {
      &:before {
        height: calc(100% + 140px) !important;
      }
    }
    ${Cta} {
      margin-bottom: 16px;
    }
  }
  ${NavButton} {
    img {
      top: 0;
    }
  }

  ${Preview} {
    padding: 0;
  }
  
  ${Thumbnail} {
    img {
      width: 80px !important;
      height: 80px !important;
      object-fit: cover !important;
    }
  }

  ${FeaturedCard} {
    &&& {
      padding-bottom: 0;
      ${Cta} {
        color: black;
      }
    }
  }

  ${ListingHeader} {
    &&& {
      & > ${Grid} {
        @media ${breakpoint.desktop} {
          margin: 64px auto 36px;
        }
      }
    }
  }

  .swiper {
    &-button-next,
    &-button-prev {
      opacity: 1;
      border-color: var(--white);

      &-button-disabled {
        opacity: 0.35;
      }
    }

    &-pagination-fraction {
      color: var(--white);
    }
  }

  .font-50 {
    &&& {
      font-size: 40px;
      line-height: 44px;

      @media ${breakpoint.desktop} {
        font-size: 50px;
        line-height: 55px;
      }
    }
  }

  .border-bottom-orange {
    &&& {
      border-bottom: 7px solid var(--warm-orange);
      display: block;
    }
  }

`

export default GlobalStyles